import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const UserIcon = ({ className, ...props }: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={mergeClassNames('h-4 w-4 text-red-400', className)}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.25 5.25C7.25 4.00736 8.25736 3 9.5 3C10.7426 3 11.75 4.00736 11.75 5.25C11.75 6.49264 10.7426 7.5 9.5 7.5C8.25736 7.5 7.25 6.49264 7.25 5.25ZM9.5 1.5C7.42893 1.5 5.75 3.17893 5.75 5.25C5.75 7.32107 7.42893 9 9.5 9C11.5711 9 13.25 7.32107 13.25 5.25C13.25 3.17893 11.5711 1.5 9.5 1.5ZM6.5 10.5C5.50544 10.5 4.55161 10.8951 3.84835 11.5984C3.14509 12.3016 2.75 13.2554 2.75 14.25V15.75C2.75 16.1642 3.08579 16.5 3.5 16.5C3.91421 16.5 4.25 16.1642 4.25 15.75V14.25C4.25 13.6533 4.48705 13.081 4.90901 12.659C5.33097 12.2371 5.90326 12 6.5 12H12.5C13.0967 12 13.669 12.2371 14.091 12.659C14.5129 13.081 14.75 13.6533 14.75 14.25V15.75C14.75 16.1642 15.0858 16.5 15.5 16.5C15.9142 16.5 16.25 16.1642 16.25 15.75V14.25C16.25 13.2554 15.8549 12.3016 15.1517 11.5984C14.4484 10.8951 13.4946 10.5 12.5 10.5H6.5Z"
      fill="currentColor"
    />
  </svg>
);

export default UserIcon;
